import {createBrowserRouter, Navigate} from 'react-router-dom'

import Home from '../views/Home/Home'
import NotFound from '../views/NotFound/NotFound'
import {useAuth} from '../components/hooks/AuthProvider'
import Login from '../views/Login/Login'
import App from '../App'

enum Route {
    ROOT = '/',
    LOGIN = '/login',
    HOME = '/home',
    FAVORITES = '/favorites',
    ACCOUNT = '/account',
    NOTFOUND = '*',
}

const PrivateRoute = () => {
    const token = localStorage.getItem('site')
    return !token ? <Navigate to="/login" /> : <App />
}

const privateRoutes = [
    {
        path: Route.HOME,
        element: <Home />,
    },
]

const routes = [
    {
        path: Route.ROOT,
        element: <App noNavbar noBottomNav />,
        children: [
            {
                path: Route.LOGIN,
                element: <Login />,
            },
            {
                path: Route.NOTFOUND,
                element: <NotFound />,
            },
        ],
    },
    {
        path: Route.ROOT,
        element: <PrivateRoute />,
        children: [...privateRoutes],
    },
]

const router = createBrowserRouter(routes)

export {router, Route}
